export const ComponentTypes = {
    Element: "Element",
    DisplayObject: "DisplayObject",
    HtmlElement: "HtmlElement",
    PlayList: "PlayList",
    Song: "Song",
    Style: "Style",
    HtmlStyle: "HtmlStyle",
    Controller: "Controller",
    LinkedElement: "LinkedElement",
    ActionSet: "ActionSet",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/ComponentTypes.ts
 **/